<div class="main">
    <!-- <div class="heading">
        <div class="line"></div>
        <h5>Flexible Learning</h5>
        <div class="line"></div>
    </div> -->
    <p>Our Executive Coaching Certification Programs</p>

    <div class="cards">
  <div class="card1" *ngFor="let pkg of packagesForUi">
    <div class="image">
      <img [src]="getLogo(pkg)" [alt]="pkg.name" height="30px" width="30px">
    </div>

    <!-- ✅ dynamic name + price -->
    <h3>{{ pkg.name }}</h3>

    <!-- ✅ KEEP description static BUT based on tier -->
    <p *ngIf="pkg.tier === 'platinum'">
      The ultimate certification experience for aspiring Executive Coaches who want to master their craft, gain ICF credentials, and launch a thriving coaching practice.
    </p>

    <p *ngIf="pkg.tier === 'gold'">
      Designed for professionals ready to elevate their coaching expertise, the Gold Package provides a balanced mix of intensive training, on-demand learning, and cutting-edge AI-driven coaching tools.
    </p>

    <p *ngIf="pkg.tier === 'silver'">
      A starter option for learners who want flexible access to core learning resources and a lighter pathway into the Academy experience.
    </p>

    <p *ngIf="pkg.tier === 'other'">
      Flexible access to Academy learning resources and training based on the selected package.
    </p>

    <h5>{{ getPriceText(pkg) }}</h5>
    <hr>

    <!-- ✅ KEEP all your long static sections, but show per tier -->
    <div class="include">

      <!-- PLATINUM STATIC CONTENT -->
      <ng-container *ngIf="pkg.tier === 'platinum'">
        <h4>Includes</h4>
        <ul>
          <li><i class="fa-regular fa-circle-check"></i> Live Virtual Intensive 2-Day Seminar</li>
          <li><i class="fa-regular fa-circle-check"></i> 10 Hours ICF Mentor Coaching</li>
          <li><i class="fa-regular fa-circle-check"></i> ICF Curriculum and Practice Test</li>
          <li><i class="fa-regular fa-circle-check"></i> Two-Year Membership to NexGen Executive Coaching Academy</li>
          <li><i class="fa-regular fa-circle-check"></i> On-Demand and Live Training Video Library</li>
          <li><i class="fa-regular fa-circle-check"></i> AI Co-Pilot Coach Assistant</li>
          <li><i class="fa-regular fa-circle-check"></i> First-Year ICF Membership Included ($245 Value)</li>
          <li><i class="fa-regular fa-circle-check"></i> Exclusive Certification after 2-Day Seminar and Passing Exam</li>
          <li><i class="fa-regular fa-circle-check"></i> Completion within 5–6 Months After 100 Hours of Paid Coaching</li>
          <li><i class="fa-regular fa-circle-check"></i> 60 Hours of Education</li>
          <li><i class="fa-regular fa-circle-check"></i> ICF Certificate (Ready to Test) for ACC or PCC</li>
        </ul>

        <h3><i class="fa-regular fa-circle-check"></i> EXCLUSIVE FEATURES</h3>
        <div class="exclusive">
          <ul>
            <li>Real-Time Barter Coaching Platform</li>
            <li>On-Demand Executive Coaching Videos</li>
            <li>Customizable AI Co-Pilot Coach Assistant</li>
            <li>One-Year Free ICF Membership ($270 Value)</li>
            <li>Join-Any-Time Live Training Webinars</li>
            <li>NexGen Executive Coaching Academy Mobile App (iOS & Android)</li>
            <li>Access to Specialty Certifications</li>
          </ul>
        </div>

        <h3><i class="fa-regular fa-circle-check"></i> ICF CERTIFICATION</h3>
        <ul>
          <li>ICF Education Hours</li>
          <li>60 Hours for ACC (Level I)</li>
          <li>125 Hours for PCC (Level II)</li>
        </ul>
        <p>Complete in just 5–6 months</p>
      </ng-container>

      <!-- GOLD STATIC CONTENT -->
      <ng-container *ngIf="pkg.tier === 'gold'">
        <h4>Includes</h4>
        <ul>
          <li><i class="fa-regular fa-circle-check"></i> Virtual Intensive 2-Day Seminar</li>
          <li><i class="fa-regular fa-circle-check"></i> Individual EQ 2.0i Assessment</li>
          <li><i class="fa-regular fa-circle-check"></i> Business Builder Workshop</li>
          <li><i class="fa-regular fa-circle-check"></i> Pre-Recorded Video & Seminar Library</li>
          <li><i class="fa-regular fa-circle-check"></i> AI Co-Pilot Coach Assistant</li>
          <li><i class="fa-regular fa-circle-check"></i> Assessment Quiz</li>
          <li><i class="fa-regular fa-circle-check"></i> Certification After Seminar and 60 Hours of Education</li>
          <li><i class="fa-regular fa-circle-check"></i> 2-Day Live Virtual Workshop (Professional Certification)</li>
        </ul>

        <h3><i class="fa-regular fa-circle-check"></i> EXCLUSIVE FEATURES</h3>
        <div class="exclusive">
          <ul>
            <li>One-Year Access to AI-Driven LMS Platform</li>
            <li>Real-Time Barter Coaching Platform</li>
            <li>Customizable AI Co-Pilot Coach Assistant</li>
            <li>Patented AI-Driven Coaching Framework</li>
            <li>Join-Any-Time Live Training Webinars</li>
            <li>NexGen Executive Coaching Academy App (Android/iOS)</li>
            <li>Access to Specialty Certifications</li>
          </ul>
        </div>

        <h3><i class="fa-regular fa-circle-check"></i> FLEXIBLE PLATINUM UPGRADE OPTIONS</h3>
        <ul>
          <li>Upgrade to Platinum for $2,000 anytime during or after Gold</li>
          <li>All Gold training counts toward Platinum with no progress lost</li>
          <li>Switch seamlessly between programs with no deadlines or penalties</li>
          <li>Maintain lifetime eligibility to upgrade</li>
        </ul>
      </ng-container>

      <!-- SILVER STATIC CONTENT (you can edit as you like) -->
      <ng-container *ngIf="pkg.tier === 'silver'">
        <h4>Includes</h4>
        <ul>
          <li><i class="fa-regular fa-circle-check"></i> Access to core LMS learning modules</li>
          <li><i class="fa-regular fa-circle-check"></i> Pre-recorded training video access</li>
          <li><i class="fa-regular fa-circle-check"></i> Community learning resources</li>
        </ul>

        <h3><i class="fa-regular fa-circle-check"></i> FEATURES</h3>
        <div class="exclusive">
          <ul>
            <li>Flexible self-paced learning</li>
            <li>On-demand resources</li>
            <li>Upgrade eligible anytime</li>
          </ul>
        </div>
      </ng-container>

    </div>

    <button (click)="buyNow(pkg)" [disabled]="isLoading">
      {{ isLoading ? 'Please wait...' : 'Buy Now' }}
    </button>
  </div>
</div>

</div>
